export default __webpack_public_path__ + "static/windows-terminal-0dec0a0a3d271f4c8be6cb27a69b3eed.png";